var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-section",class:_vm.isLight ? 'light-bg' : ''},[_c('div',{staticClass:"title-text",class:_vm.isMobile ? 'title-mobile' : ''},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }